import { getRoute } from '.'
import { DB } from './database'
import { Route } from './models'

export const fetchRoute = async (routeId: string) => {
  return DB.getRoute(routeId)
}

export const fetchRouteGeometry = async (routeId: string) => {
  return DB.getRouteGeometry(routeId)
}

export const fetchUserRoutes = async (userId: string | undefined) => {
  if (!userId) throw new Error('User not logged in')
  const routes = await DB.getUserRoutes(userId)
  return routes
}

export const saveRoute = async (route: Route): Promise<Route> => {
  await DB.updateRoute(route.id, route)
  route.saved = true
  return route
}

export const saveRouteById = async (routeId: string): Promise<Route> => {
  const route = getRoute(routeId)
  return saveRoute(route)
}
